<h1 mat-dialog-title translate="UI.USER.LINKED_ACCOUNTS.ACTIVATE.ACTIVATE"></h1>

<div mat-dialog-content>
  <p translate="UI.USER.LINKED_ACCOUNTS.ACTIVATE.HELP_DIALOG"></p>
  <shared-form-editor [config]="config"></shared-form-editor>
</div>
